import {
  Branch,
  Playground,
  isPlayground,
} from '@basehub/data/replicache/index'
import { PLAYGROUND_EXPIRATION_TIME_MS } from '@basehub/shared-constants'
import Cookies from 'js-cookie'

export const getPlaygroundExpirationDate = (playground: Playground) => {
  // playground expires 5 days from its creation
  const expirationDate = playground.playgroundExpiresAt
  if (expirationDate) return new Date(expirationDate)

  const defaultExpirationDate = new Date(playground.createdAt)
  defaultExpirationDate.setMilliseconds(
    defaultExpirationDate.getDate() + PLAYGROUND_EXPIRATION_TIME_MS
  )
  return defaultExpirationDate
}

export const PLAYGROUND_ID_COOKIE_NAME = 'playgroundId'

export const getPlaygroundIdCookie = () => {
  return Cookies.get(PLAYGROUND_ID_COOKIE_NAME)
}

export const getPlaygroundDisplayName = (branch: Branch) => {
  if (!isPlayground(branch)) return branch.name

  const firstPart = branch.name.split('-')[0]
  if (firstPart) return firstPart

  return branch.name
}
